import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom'
import { useState, useEffect } from "react"

export const Footer = ({ clubData, getClub }) => {
  const currentYear = new Date().getFullYear();
  // const url = process.env.REACT_APP_URL

  const [club, setClub] = useState([])

  useEffect(() => {
    getClub()
  }, [getClub])

  useEffect(() => {
    if (clubData) {
      setClub(clubData)
    }
  }, [clubData])

  // console.log('club', club)

  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={6}>
            {club._id ?
              <div inline='true' className="m-2">
                <p>{club?.type}</p>
                <h4>{club?.name}</h4>
                <p>
                  {`Club Number: ${club?.number}`}<br />
                  {`Area: ${club?.area}, Division ${club?.division}, District ${club?.district}, Region ${club?.region}`}
                </p>
              </div>
              : ''
            }
          </Col>
          <Col xs={12} md={6} xl={6} className="text-center text-sm-end">
            <Row className="social-icon">
              {club &&
                <Col className="text-end">
                  {club.linkedInVisible && <a href={club.linkedIn ? club.linkedIn : ''} target="_blank" rel="noreferrer"><i className="bi bi-linkedin" /></a>}
                  {club.facebookVisible && <a href={club.facebook ? club.facebook : ''} target="_blank" rel="noreferrer"><i className="bi bi-facebook" /></a>}
                  {club.instagramVisible && <a href={club.instagram ? club.instagram : ''} target="_blank" rel="noreferrer"><i className="bi bi-instagram" /></a>}
                  {club.xVisible && <a href={club.x ? club.x : ''} target="_blank" rel="noreferrer"><i className="bi bi-twitter-x" /></a>}
                  {club.youtubeVisible && <a href={club.youtube ? club.youtube : ''} target="_blank" rel="noreferrer"><i className="bi bi-youtube" /></a>}
                </Col>
              }
            </Row>
            <Row className="text-end">
              <Col className="text-end">
                <p className="text-end">© {currentYear}. All Rights Reserved. Developed and maintained by <a href="https://marius-c.webhop.me/" target="_blank" rel="noreferrer">marius-c</a></p>
                <p className="text-end"><Link to={'/t&c'}>Terms and Conditions</Link></p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}